import { create } from "@storybook/theming/create";

export default create({
  base: "light",
  // UI
  appBg: "white",
  appContentBg: "white",
  appBorderColor: "grey",
  appBorderRadius: 4,
  brandTitle: "Leybold - Design System",
  brandUrl: "https://www.leybold.com/",
  brandImage:
    "https://www.leybold.com/etc.clientlibs/settings/wcm/designs/leybold/clientlib-preloaded/resources/img/svg/logo.svg",
  brandTarget: "_self",
});

